// extracted by mini-css-extract-plugin
module.exports = {"course-accordion-list__wrapper":"CourseAccordionList_course-accordion-list__wrapper__rki7D"};